var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 533.33 533.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0b0e11;}.cls-2{fill:#f0b90b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8CC7\u7522 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.67,
    cy: 266.67,
    r: 266.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.86,235.93l74.81-74.8L341.51,236,385,192.44,266.67,74.07,148.34,192.4ZM117.6,223.14l43.53,43.52L117.6,310.19,74.07,266.67Zm74.26,74.26,74.81,74.8,74.84-74.84,43.55,43.51,0,0L266.67,459.26,148.34,340.93l-.07-.06Zm267.4-30.73L415.74,310.2l-43.53-43.53,43.53-43.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.81,266.64h0l-44.16-44.16-44.19,44.19.06.06,44.13,44.13,44.18-44.19Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbChain);
export default __webpack_public_path__ + "static/media/BNB-chain.6b0f327347ee7f8448c4afb07ef4a83b.svg";
export { ForwardRef as ReactComponent };